export default __webpack_public_path__ + "static/media/connectivity-Header-4k.c422a974.jpg";